import React from 'react'
import { Users, Trophy, TrendingUp, Star, Activity, ArrowUpRight, BarChart3 } from 'lucide-react'
import { useLanguage } from '../i18n'
import TeamDashboard from '../components/TeamDashboard'

const TeamPage = ({ isConnected, userAddress }) => {
  const { t } = useLanguage()
  
  const teamStats = [
    { icon: Users, value: '847', label: t('team.activeFleets'), change: 12.8, changeLabel: t('fuel.thisWeek'), color: 'gold' },
    { icon: Trophy, value: '2,561', label: t('team.totalMembers'), change: 18.5, changeLabel: t('fuel.thisMonth'), color: 'blue' },
    { icon: TrendingUp, value: '3.2M', label: t('team.totalContribution'), change: 22.3, changeLabel: t('team.lastWeek'), color: 'green' },
    { icon: Star, value: 'Top 100', label: t('team.rankingCompetition'), change: 0, changeLabel: t('team.ongoing'), color: 'cyan' }
  ]

  const features = [
    {
      icon: Users,
      title: t('team.referralBinding'),
      description: t('team.referralBindingDesc')
    },
    {
      icon: Trophy,
      title: t('team.weeklyRanking'),
      description: t('team.weeklyRankingDesc')
    },
    {
      icon: TrendingUp,
      title: t('team.teamContribution'),
      description: t('team.teamContributionDesc')
    },
    {
      icon: Star,
      title: t('team.honorDisplay'),
      description: t('team.honorDisplayDesc')
    }
  ]

  return (
    <div className="min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 页面标题 */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-titanium-gold/10 border border-titanium-gold/30 rounded-full px-4 py-2 mb-6">
            <Users className="w-4 h-4 text-titanium-gold" />
            <span className="text-sm font-semibold text-titanium-gold uppercase tracking-wider">{t('team.teamSystem')}</span>
          </div>
          <h1 className="tech-title text-5xl md:text-6xl font-bold mb-4">
            {t('team.title')}
          </h1>
          <p className="tech-subtitle text-xl max-w-3xl mx-auto">
            {t('team.subtitle')}
          </p>
        </div>

        {/* 舰队统计 */}
        <div className="mb-12">
          <div className="tech-grid tech-grid-4">
            {teamStats.map((stat, idx) => (
              <div key={idx} className="stat-card">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                    {stat.change !== undefined && (
                      <div className={`stat-change ${stat.change >= 0 ? 'positive' : 'negative'}`}>
                        {stat.change >= 0 ? <ArrowUpRight className="w-4 h-4" /> : <ArrowUpRight className="w-4 h-4 rotate-180" />}
                        <span>{Math.abs(stat.change)}%</span>
                        {stat.changeLabel && <span className="ml-1 opacity-70">{stat.changeLabel}</span>}
                      </div>
                    )}
                  </div>
                  <div className="icon-tech">
                    <stat.icon className="w-7 h-7" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 功能特性 */}
        <div className="mb-12">
          <div className="text-center mb-8">
            <h2 className="tech-title text-3xl font-bold mb-3">{t('team.systemFeatures')}</h2>
            <p className="tech-subtitle text-lg">{t('team.systemFeaturesDesc')}</p>
          </div>
          <div className="tech-grid tech-grid-2">
            {features.map((feature, idx) => (
              <div key={idx} className="glass-card p-8">
                <div className="icon-tech mb-6">
                  <feature.icon className="w-8 h-8" />
                </div>
                <h3 className="tech-title text-xl font-bold mb-3">{feature.title}</h3>
                <p className="tech-subtitle">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 舰队仪表盘 */}
        <div className="glass-card gold-border">
          <div className="p-8">
            <div className="text-center mb-8">
              <h2 className="tech-title text-3xl font-bold mb-3">{t('team.dashboard')}</h2>
              <p className="tech-subtitle text-lg">{t('team.dashboardDesc')}</p>
            </div>
            <TeamDashboard
              isConnected={isConnected}
              walletAddress={userAddress}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeamPage
